// extracted by mini-css-extract-plugin
export var fadeIn = "_kb-1";
export var modalContent = "_kb-3";
export var overlay = "_kb-0";
export var popoverContent = "_kb-2";
export var results = "_kb-5";
export var searchInputWrapper = "_kb-4";